import { Injectable, EventEmitter } from '@angular/core';
import { SelectedClientModel } from '@models/selected-client.model';

/**
 * sidebar service
 */
@Injectable({
    providedIn: 'root'
})
export class SidebarService {
    selectedClientData: EventEmitter<SelectedClientModel> = new EventEmitter();
    clientListForceReload: EventEmitter<string> = new EventEmitter();
    pickClientEmitter: EventEmitter<{ username?: string; skipNotify?: boolean; }> =
      new EventEmitter<{ username?: string; skipNotify?: boolean; }>();
    pickClientByIdEmitter: EventEmitter<{ clientId: number; skipNotify?: boolean; }> =
      new EventEmitter<{ clientId: number; skipNotify?: boolean; }>();
    bankListReload: EventEmitter<number> = new EventEmitter<number>();
    collapseStatusHasChanged: EventEmitter<boolean> = new EventEmitter();
    selectedBankChanged: EventEmitter<{ bankId: number; source: string; }> = new EventEmitter();

    /**
     * emit selected client data
     * @param selectedClientData
     * @param bankListChanged
     */
    emitSelectedClient(selectedClientData: SelectedClientModel, bankListChanged = false) {
        this.selectedClientData.emit({...selectedClientData, bankListChanged});
    }

    reloadClientsList(usernameToPick?: string) {
        this.clientListForceReload.emit(usernameToPick);
    }

    /**
     * detect if bank list has changed
     * sets new bank id if sent
     */
    reloadBankList(bankId?: number) {
        this.bankListReload.emit(bankId);
    }

    detectIfCollapseStatusHasChanged(isLarge: boolean) {
        this.collapseStatusHasChanged.emit(isLarge);
    }

    updateSelectedBank(bankId: number, source?: string) {
        this.selectedBankChanged.emit({bankId, source});
    }

    pickClient(username?: string, skipNotify?: boolean) {
        this.pickClientEmitter.emit({username, skipNotify});
    }

    pickClientById(clientId: number, skipNotify?: boolean) {
        this.pickClientByIdEmitter.emit({clientId, skipNotify});
    }
}

